import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Box, Typography, helperMargin } from '@utex/ui-kit';
import { Container } from './styles';

interface Props {
  hide: () => void;
  secure: () => void;
}

export const LoginWith2FARecomendation: React.FC<Props> = ({ hide, secure, ...other }) => {
  const { t } = useTranslation('loginWith2FARecomendation');

  return (
    <Container {...other}>
      <Box marginBottom={11}>
        {t('Secure your account')}
        <br />
        {t('Enable 2fa login')}
      </Box>
      <Box display="flex">
        <Button
          view="error"
          size="S"
          data-testid="login-with-2fa-recomendation-secure-btn"
          data-gtm="login-with-2fa-recomendation-secure-btn"
          onClick={secure}
        >
          <Typography.Text ellipsis={true}>{t('Secure account')}</Typography.Text>
        </Button>

        <Button
          view="error-dim"
          size="S"
          css={helperMargin({ left: 11 })}
          data-testid="login-with-2fa-recomendation-hide-btn"
          data-gtm="login-with-2fa-recomendation-hide-btn"
          onClick={hide}
        >
          {t('Later')}
        </Button>
      </Box>
    </Container>
  );
};
